import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Link } from 'react-router-dom';
import { Container, H1SectionTitle, SectionTitle } from '../../components';

export const TopSection = styled.section`
  background-color: ${(props) => props.theme.color.blue.lightBlue};
  position: relative;
`;

export const ProAvatarImage = styled.img`
  object-fit: cover;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
`;

export const TopDecoration = styled.img`
  z-index: 1;
  position: absolute;
  right: 0px;
  bottom: 0;
  max-width: 900px;
  ${mediaQuery('desktop')} {
    max-width: 680px;
    right: 0px;
  }
  ${mediaQuery('medium')} {
    max-width: 450px;
  }
  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const TopContainer = styled(Container)`
  min-height: 760px;
  display: flex;
  align-items: center;

  position: relative;

  ${mediaQuery('desktop')} {
    min-height: 720px;
  }

  ${mediaQuery('tablet')} {
    min-height: auto;
    padding-top: 40px;
    padding-bottom: 60px;
  }
`;

export const TopContainerContent = styled.div`
  min-width: 500px;
  z-index: 2;
  ${mediaQuery('tablet')} {
    margin: auto;
  }
  ${mediaQuery('small')} {
    min-width: 0;
  }
`;

export const TopContainerTitle = styled(H1SectionTitle)`
  color: ${(props) => props.theme.color.blue.default};
  text-align: center;
  ${responsiveFontSize(44, 6)}

  ${mediaQuery('phone')} {
    font-size: 28px;
  }
`;

export const TopSearchCard = styled.div`
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
  padding: 30px 25px 15px 25px;
  background-color: white;

  padding: 35px 40px;
  border-radius: 5px;
  color: ${(props) => props.theme.color.light.default};
  box-shadow: 0 3px 8px 0 rgba(0, 0, 48, 0.18);

  ${mediaQuery('phone')} {
    padding: 25px 30px;
    margin-top: 50px;
  }
`;

export const TopSearchCardLink = styled(Link)`
  display: block;
  font-size: 14px;
  white-space: nowrap;
  margin-top: 10px;
  text-align: center;
  width: 100%;
`;

export const StepsTitle = styled(SectionTitle)`
  color: ${(props) => props.theme.color.blue.default};
  margin-bottom: 60px;
`;

export const StepsItemsContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  & > *:not(:last-child) {
    margin-right: 15px;
  }
  ${mediaQuery('tablet')} {
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 15px;
    }
    align-items: center;
    flex-direction: column;
  }
`;

export const StepsItemCard = styled.div`
  width: 360px;
  ${mediaQuery('desktop')} {
    width: 300px;
  }
  /* height: 360px; */
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0px 0px 90px #00000029;
  border-radius: 10px;
  padding: 30px 20px;
  font-size: 18px;
  text-align: center;
  font-weight: 500;
`;

export const StepsItemCardImg = styled.img`
  width: 100%;
  height: 160px;
  object-fit: contain;
`;

export const StepsItemCardText = styled.p`
  margin: 0 20px;
  font-size: 18px;
`;

export const Subtitle = styled.div`
  margin: auto;
  font-size: 18px;
  max-width: 680px;
  padding: 15px 0;
`;

export const SliderContainer = styled(Container)`
  margin-top: 75px;
  margin-bottom: 75px;
`;

export const TestimonialsWrapper = styled.div`
  margin-top: 75px;
  margin-bottom: 75px;
`;

export const BlueSectionTitle = styled(SectionTitle)`
  color: ${(props) => props.theme.color.blue.default};
`;
